import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismTooltipHeader } from '@mylighthouse/prism-ember';
import type { BeniMetaComparisonSet } from 'lumen/models';
import {
  BENI_COMPARISON_SET_LONG_TRANSLATIONS,
  type Kpi,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

interface HotelBenchmarkInsightTooltipsSharedTooltipTitleSignature {
  Args: {
    isPast: boolean;
    pickupTranslation?: string;
    prefix: string;
    primaryComparisonSetMeta: BeniMetaComparisonSet | null;
    selectedKpi: Kpi;
    showMix: boolean;
    // Don't pass pickupTranslation if we don't want to show pickup
    varianceTranslation?: string;
  };
}

export default class HotelBenchmarkInsightTooltipsSharedTooltipTitle extends Component<HotelBenchmarkInsightTooltipsSharedTooltipTitleSignature> {
  @service declare access: Services['access'];
  @service declare intl: Services['intl'];

  get tooltipHeaderText(): string {
    const {
      primaryComparisonSetMeta,
      varianceTranslation,
      pickupTranslation,
      isPast,
      prefix,
      showMix,
    } = this.args;
    const showPickup =
      this.access.hasBenchmarkInsightPickupData && pickupTranslation && !isPast;

    const primaryComparisonSetTranslation = primaryComparisonSetMeta
      ? this.intl.t(
          BENI_COMPARISON_SET_LONG_TRANSLATIONS[
            primaryComparisonSetMeta.comparisonSetType
          ],
        )
      : null;

    const correctPickupTranslation = showMix
      ? varianceTranslation
      : pickupTranslation;

    if (showPickup && primaryComparisonSetTranslation) {
      // Tue 5 Mar 2024 - Pickup vs. 7 d. ago - vs. Market class
      return `${prefix} - ${correctPickupTranslation} - ${this.intl.t(
        'benchmark_insight.versus.comparison_set',
        {
          comparisonSet: primaryComparisonSetTranslation,
        },
      )}`;
    }

    if (showPickup) {
      return `${prefix} - ${correctPickupTranslation}`;
    }

    if (primaryComparisonSetTranslation) {
      return `${prefix} - ${this.intl.t(
        'benchmark_insight.versus.comparison_set',
        {
          comparisonSet: primaryComparisonSetTranslation,
        },
      )}`;
    }

    return prefix;
  }

  <template>
    <PrismTooltipHeader class="tooltip-title">
      {{this.tooltipHeaderText}}
    </PrismTooltipHeader>
  </template>
}
